/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementCutStrategyApplyMode {
    ALL_PAYMARKETS = 'all_paymarkets',
    PER_PAYMARKET = 'per_paymarket',
}
